import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.apiUrl}/provider`;


class ClaimsService {
  getAuthHeaders() {
    return {
      headers:{
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_tk")}`,
      }
    }
  }

  async getClaims() {
    try{
      const response = await axios.get(
        `${BASE_URL}/policy/get/all/claimed`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data?.data?.reason || "Claims fetched successfully",
        data: response.data?.data,
      };
    }catch(error){
      return {
        status: false,
        message: error.response?.data?.data?.reason || "An error occurred while getting claims",
        data: null,
      }
    }
  }

  async updateClaimStatus(claimSlug, status, rejectReason = null, claim_slug) {
    try {
      // Map UI status values to API status values
      // Note: API uses "reviewing" instead of "reviewed"
      const statusMap = {
        "received": "received",
        "reviewed": "reviewing", // Map "reviewed" to "reviewing" for API
        "reviewing": "reviewing", // Also handle "reviewing" directly
        "claimed": "claimed",
        "rejected": "rejected",
        "pending": "pending", // For backward movement
      };

      const apiStatus = statusMap[status] || status;
      
      const payload = {
        claim_slug: claimSlug,
        claim_status: apiStatus
      };
      
      if (rejectReason) {
        payload.reject_reason = rejectReason;
      }

      const response = await axios.post(
        `${BASE_URL}/policy/update/claim_status/${claim_slug}`,
        payload,
        this.getAuthHeaders()
      );
      
      return {
        status: true,
        message: response.data?.data?.reason || response.data?.message || "Claim status updated successfully",
        data: response.data?.data,
      };
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.data?.reason || error.response?.data?.message || "An error occurred while updating claim status",
        data: null,
      };
    }
  }
}

const claimsService = new ClaimsService();
export default claimsService;